export const colors = {
    brand: {
        teal: {
            10: '#002019', 20: '#00382B', 30: '#00513F', 40: '#0E7C66',
            50: '#2E9D84', 60: '#4DBFA3', 70: '#6FDCBF', 80: '#A8F2DD', 90: '#CDFBEA', 95: '#E6FDF4', 99: '#F7FFFB',
            accent: '#2CCFAA',
            glow: 'rgba(46, 207, 170, 0.15)',
        },
        graphite: {
            10: '#0B0F14', 20: '#141A22', 30: '#1F2733', 40: '#334155',
            60: '#6B7280', 80: '#C7CDD6', 95: '#E6E9EF', 99: '#FAFAF7',
        },
        citrus: { 40: '#A17A00', 60: '#F5B400', 80: '#FFD766' },
        error: { 40: '#B3261E', 60: '#E65A54', 80: '#F8B4B0' },
        retro: {
            grid: 'rgba(14, 124, 102, 0.04)',
            gridDark: 'rgba(46, 207, 170, 0.03)',
        },
    },
};
export const typography = {
    family: {
        display: "'Space Grotesk Variable', 'Manrope Variable', system-ui, sans-serif",
        body: "'Inter Variable', system-ui, sans-serif",
        mono: "'JetBrains Mono', ui-monospace, monospace",
    },
};
export const shape = {
    corner: { none: 0, xs: 4, sm: 8, md: 12, lg: 16, xl: 28, full: 9999 },
};
export const motion = {
    duration: { short: 200, medium: 300, long: 500 },
    easing: {
        expressive: 'cubic-bezier(0.22, 1, 0.36, 1)',
        standard: 'cubic-bezier(0.4, 0, 0.2, 1)',
    },
};
export const glass = {
    light: {
        background: 'rgba(255, 255, 255, 0.7)',
        border: 'rgba(14, 124, 102, 0.12)',
        blur: 16,
    },
    dark: {
        background: 'rgba(20, 26, 34, 0.6)',
        border: 'rgba(46, 207, 170, 0.12)',
        blur: 20,
    },
};
